import { createAssessmentClientState } from '@repo/assessment';
import type { IEnglishIqDemoV2, IEnglishIqResultV2 } from '@repo/sdk';
import type { IEnglishIqV2StoredFlow } from '../english-iq-v2-stored-flow';

export interface IEnglishIqV2WebState extends Omit<IEnglishIqV2StoredFlow, 'ownerSubject'> {
  error: string | null;
  hydrated: boolean;
  ownerSubject: string | null;
}

export function createEnglishIqV2WebState(sourceShareId: string | null): IEnglishIqV2WebState {
  return {
    assessment: createAssessmentClientState(12),
    demo: null as IEnglishIqDemoV2 | null,
    error: null,
    expiresAt: 0,
    hydrated: false,
    ownerSubject: null,
    pendingCompletionId: null,
    pendingResult: null as IEnglishIqResultV2 | null,
    pendingAnswer: null,
    sourceShareId,
    view: 'start',
  };
}
